// pages/QuestionnaireObesityFemale.tsx
import QuestionnaireForm from '../components/QuestionnaireForm';
const QuestionnaireObesityFemale = () => (
  <QuestionnaireForm questionFile="obesityfemale_questions.json" service="obesity_female" />
);
export default QuestionnaireObesityFemale;
